import axios from 'axios';
import router from '../router/index';
import Store from './index';
import config from './config';

//instantiate axios instance
const axios_instance = axios.create({
  baseURL: config.api.url,
  headers: { 'Content-Type': 'application/json' },
  timeout: 20000,
  withCredentials: true
});
// Here we intercept every AXIOS response in the Vue instance and logout the user if we receive 401
axios_instance.interceptors.response.use( response => {
  return response;
  }, (error) => {
    if(error.response && error.response.status === 401) {
      Store.dispatch('RESET');
      router.push('/login');
    }
    return Promise.reject(error);
});

export default axios_instance;
